import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { useApiAccess } from "./useApiAccess";
import { getCategoryBySlug } from "../../Service/CategoryService";
import { queryKeys } from "./queryKeys";

export function useCategoryBySlug({ categorySlug }) {
  const hasAccess = useApiAccess();
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const pathParams = { ...(productParam && { product: productParam }) };

  return useQuery(
    queryKeys.categoryBySlug(categorySlug, productParam),
    () => getCategoryBySlug({ categorySlug }, pathParams),
    { enabled: !!hasAccess && !!categorySlug }
  );
}
